import { takeLatest, put, call, fork } from "redux-saga/effects";
import { message } from "antd";
import { BANK_STATEMENT_ANALYSER_ACTIONS } from "constants/actions";
import {
    createdRequest,
    failedCreateRequest,
    fetchJobsList,
    fetchedJobsList,
    failedFetchJobsList,
    fetchedJobsDetails,
    failedFetchJobsDetails,
    fetchedStatementAnalysis,
    failedFetchStatementAnalysis,
    retryAnalysisSucceed,
    retryAnalysisFailed,
    fetchStatementAnalysisPerfois,
    fetchStatementAnalysis as fetchStatementAnalysisAction
} from "store/actions";
import CaseService from "services/case-service";

function* createJob({ payload : { caseId, requestData } }) {
    message.loading("Creating Request...", 0);
    try {
        const {data, error} = yield call(
            CaseService.uploadBankStatementAnalysis,
            requestData
        );
        if(!error) {
            message.destroy();
            message.success("Request Created Successfully");
            yield put(createdRequest(caseId, data));
            yield put(fetchJobsList(caseId));
        } else {
            message.destroy();
            message.error("Failed to Create Request");
            yield put(failedCreateRequest(caseId, requestData, error));
        }
    } catch(error) {
        message.destroy();
        message.error(error.status);
        message.error(error.error);
        yield put(failedCreateRequest(caseId, requestData, error));
    }
}

function* createPerfiosJob({ payload : { caseId, requestData } }) {
    message.loading("Creating Request...", 0);
    try {
        const {data, error} = yield call(
            CaseService.uploadBankStatementAnalysisPerfios,
            requestData
        );
        if(!error) {
            message.destroy();
            message.success("Request Created Successfully");
            yield put(createdRequest(caseId, data));
            yield put(fetchJobsList(caseId));
        } else {
            message.destroy();
            message.error("Failed to Create Request");
            yield put(failedCreateRequest(caseId, requestData, error));
        }
    } catch(error) {
        message.destroy();
        message.error(error.status);
        message.error(error.error);
        yield put(failedCreateRequest(caseId, requestData, error));
    }
}

function* fetchJobListHandler({ payload : { caseId } }) {
    try {
        const {data, error} = yield call(
            CaseService.getJobList,
            caseId
        );
        if(!error) {
            yield put(fetchedJobsList(caseId, data));
            if (data.results && data.results.length == 1 && data.results[0].current_status == 5 && data.results[0].using == false){
                if(data.results[0].provider){
                    yield put(fetchStatementAnalysisPerfois(caseId, data.results[0].analysis_request))
                }else{
                    yield put(fetchStatementAnalysisAction(caseId, data.results[0].analysis_request));
                }
            }
        } else {
            yield put(failedFetchJobsList(caseId, error));
        }
    } catch(error) {
        yield put(failedFetchJobsList(caseId, error));
    }
}

function* fetchJobDetails({ payload : { caseId, jobId } }) {
    try {
        const {data, error} = yield call(
            CaseService.getJobDetails,
            jobId
        );
        if(!error) {
            yield put(fetchedJobsDetails(caseId, jobId, data));
        } else {
            yield put(failedFetchJobsDetails(caseId, jobId, error));
        }
    } catch(error) {
        yield put(failedFetchJobsDetails(caseId, jobId, error));
    }
}

function* fetchJobDetailsPerfios({ payload : { caseId, jobId } }) {
    try {
        const {data, error} = yield call(
            CaseService.getJobDetailsPerfios,
            jobId
        );
        if(!error) {
            yield put(fetchedJobsDetails(caseId, jobId, data));
        } else {
            yield put(failedFetchJobsDetails(caseId, jobId, error));
        }
    } catch(error) {
        yield put(failedFetchJobsDetails(caseId, jobId, error));
    }
}

function* fetchStatementAnalysis({ payload : { caseId, requestId } }) {
    try {
        const {data, error} = yield call(
            CaseService.getStatementAnalysis,
            requestId
        );
        if(!error) {
            yield put(fetchedStatementAnalysis(caseId, requestId, data));
        } else {
            yield put(failedFetchStatementAnalysis(caseId, requestId, error));
        }
    } catch(error) {
        yield put(failedFetchStatementAnalysis(caseId, requestId, error));
    }
}

function* fetchStatementAnalysisPerfios({ payload : { caseId, requestId } }) {
    try {
        const {data, error} = yield call(
            CaseService.getStatementAnalysisPerfios,
            requestId
        );
        if(!error) {
            yield put(fetchedStatementAnalysis(caseId, requestId, data));
        } else {
            yield put(failedFetchStatementAnalysis(caseId, requestId, error));
        }
    } catch(error) {
        yield put(failedFetchStatementAnalysis(caseId, requestId, error));
    }
}

function* retryAnalysis({ payload: {caseId, requestId} }) {
    try {
        message.info("Retry Request has been Retriggered");
        const {data, error} = yield call(
            CaseService.retryAnalysis,
            requestId
        );
        if(!error) {
            message.success("Analysis Request Retriggered");
            yield put(retryAnalysisSucceed(caseId, requestId, data));
            yield put(fetchJobsList(caseId));
        } else {
            message.error("Failed to retrigger the request");
            yield put(retryAnalysisFailed(caseId, requestId, error));
        }
    } catch(error) {
        message.error("Failed to retrigger the request");
        yield put(retryAnalysisFailed(caseId, requestId, error));
    }
}

function* retryAnalysisPerfios({ payload: {caseId, requestId} }) {
    try {
        message.info("Retry Request has been Retriggered");
        const {data, error} = yield call(
            CaseService.retryAnalysisPerfios,
            requestId
        );
        if(!error) {
            message.success("Analysis Request Retriggered");
            yield put(retryAnalysisSucceed(caseId, requestId, data));
            yield put(fetchJobsList(caseId));
        } else {
            message.error("Failed to retrigger the request");
            yield put(retryAnalysisFailed(caseId, requestId, error));
        }
    } catch(error) {
        message.error("Failed to retrigger the request");
        yield put(retryAnalysisFailed(caseId, requestId, error));
    }
}

export default fork(function*() {
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.CREATE_ANALYSER_REQUEST, createJob);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.CREATE_ANALYSER_REQUEST_PERFIOS, createPerfiosJob);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_ANALYSER_JOBS, fetchJobListHandler);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_REQUEST_DETAILS, fetchJobDetails);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_REQUEST_DETAILS_PERFIOS, fetchJobDetailsPerfios);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.RETRY_ANALYSIS, retryAnalysis);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.RETRY_ANALYSIS_PERFIOS, retryAnalysisPerfios);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_STATEMENT_ANALYSIS, fetchStatementAnalysis);
    yield takeLatest(BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_STATEMENT_ANALYSIS_PERFIOS, fetchStatementAnalysisPerfios);
});